// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/_enum-bug-keys.js
// module id = 283
// module chunks = 0 1